function RightPopup() {
    return(
        <>
            <img src={"Filter bubble.png"} className={"filter-bubble"} id={"right-popup"}></img>
        </>
    )
}

export default RightPopup